import { useTenant } from '../contexts/TenantContext';

/** The two roles the API treats as a tenant admin (`TenantService.ADMIN_ROLES`). */
const ADMIN_ROLES = new Set(['owner', 'admin']);

/**
 * Whether the signed-in user administers the selected tenant, for hiding write
 * actions. Presentation only: the API still refuses every write from anyone
 * else, so a stale answer here costs a clear error, never a bypass.
 */
export function useIsTenantAdmin(): boolean {
  const { selectedTenant, availableTenants } = useTenant();
  const membership = availableTenants.find((t) => t.tenantId === selectedTenant?.id);
  return !!membership && ADMIN_ROLES.has(membership.role);
}
